import React from 'react';
import { Helmet } from 'react-helmet';
import { MdDelete } from 'react-icons/md';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import SaveMessage from 'components/SaveMessage';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import RoleButton from 'components/RoleButton';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import EquipmentSetsVirtualizedTable from './components/EquipmentSetsVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export class EquipmentSets extends React.PureComponent<{}> {
    render(): React.ReactElement {
        return (
            <ErrorBoundary
                namespace="EquipmentSets"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Equipment Sets - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <PageTitleAndFilters
                    title="Equipment Sets"
                    searchInputPlaceholder="Search"
                    hideFilters
                    MessageComponent={
                        <SaveMessage
                            namespace={[
                                'EQUIPMENT_SET_CREATE',
                                'EQUIPMENT_SET_UPDATE',
                                'EQUIPMENT_SET_DELETE'
                            ]}
                        />
                    }
                    FirstActionButton={
                        <SingleActiveTableRowGate>
                            <RoleButton
                                requiredRoles={[
                                    ADMIN,
                                    MANAGER,
                                    ASSISTANT_MANAGER
                                ]}
                                params={{
                                    [DELETE_MODAL_QUERY_STRING_PARAM]: true
                                }}
                                buttonProps={{
                                    icon: true,
                                    color: 'black',
                                    basic: true,
                                    style: {
                                        marginRight: 0,
                                        marginLeft: 8
                                    }
                                }}
                            >
                                <ButtonIconWrapper>
                                    <MdDelete
                                        style={{
                                            fontSize: 20
                                        }}
                                    />
                                </ButtonIconWrapper>
                                Delete
                            </RoleButton>
                        </SingleActiveTableRowGate>
                    }
                    SecondActionButton={
                        <RoleButton
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                [CREATE_MODAL_QUERY_STRING_PARAM]: true
                            }}
                            buttonProps={{
                                secondary: true,
                                style: {
                                    marginRight: 0,
                                    marginLeft: 8
                                }
                            }}
                        >
                            Create New
                        </RoleButton>
                    }
                />
                <PageTitleAndFiltersPusher>
                    <EquipmentSetsVirtualizedTable tableId="equipment-sets" />
                </PageTitleAndFiltersPusher>
            </ErrorBoundary>
        );
    }
}

export default EquipmentSets;
